import React from 'react'
import { ImageOrAutoplayVideo } from 'marketing-site/src/library/elements/ImageOrAutoplayVideo'
import { IImageOrVideo } from './index'
import { WistiaVideo } from '../../elements/WistiaVideo'

export default function EditorialImageOrVideo(props: IImageOrVideo) {
  const width = props.width ? `${props.width}px` : 'auto'

  return (
    <div className="editorial-wrap__image-or-video-with-caption">
      <div className="editorial-wrap__image-or-video-with-caption--asset" style={{ width }}>
        {props.wistiaId ? (
          <WistiaVideo wistiaId={props.wistiaId} title={props.caption ? props.caption : ''} />
        ) : (
          <ImageOrAutoplayVideo {...props} />
        )}
      </div>
      {props.caption && (
        <div className="editorial-wrap__image-or-video-with-caption--caption">{props.caption}</div>
      )}
    </div>
  )
}
